import { Cache } from "memory-cache";
import { StaticStorageClient } from "../service/staticstorageclient";
import { RegionEntity } from ".";

// Static Storage Client
const dataClient = new StaticStorageClient();

// Cache
const cache = new Cache();

export async function getCachedRegionEntity(region_id: number): Promise<RegionEntity | null> {
  let entity: any = await cache.get(region_id.toString());
  if (entity) {
    return entity;
  }
  try {
    const system = await dataClient.get_region_by_id(region_id);
    if (system !== null) {
      entity = new RegionEntity(region_id, system);
      cache.put(region_id.toString(), entity, 60 * 60 * 1000 /* 1 hour */);
      return entity;
    } else {
      return null;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
}
export async function getCachedRegionListBySearchString(searchstring: string, strict: boolean): Promise<any> {
  const list = await dataClient.get_region_by_string(searchstring, strict);
  let entities = [];
  if (list !== null) {
    for (const y of list) {
      entities.push(y.regionID);
    }
    if (entities.length) {
      return entities;
    } else {
      return [];
    }
  }
}
